module.exports = __webpack_public_path__ + "static/media/tutorialsroll.05063794.webp";